import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ProgressIndicatorSpinnerIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M7 5V1H3l1.334 1.334a6.722 6.722 0 1 0 10.48 5.573h-2a4.723 4.723 0 1 1-7.027-4.12L7 5ZM12 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z M15 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
  </IconWrapper>
)

export default ProgressIndicatorSpinnerIconSmall
